export function getBrandCategories(categories: string[]) {
  return categories
    .map((name, index) => ({ name, index }))
    .filter((category) => category.name !== "All")
}

export function getBrandCategoryIndex(
  value: string | string[] | undefined,
  categories: string[]
) {
  if (typeof value !== "string" || !/^\d+$/.test(value)) return undefined
  const index = Number(value)
  return Number.isSafeInteger(index) &&
    categories[index] !== undefined &&
    categories[index] !== "All"
    ? index
    : undefined
}

export function getBrandStoreSearchParams(
  page: number,
  size: number,
  categoryIndex?: number
) {
  return {
    page,
    size,
    status: 1,
    ...(categoryIndex === undefined ? {} : { category: categoryIndex }),
  }
}

export function getBrandsHref(page = 1, categoryIndex?: number) {
  const params = new URLSearchParams()
  if (page > 1) params.set("page", String(page))
  if (categoryIndex !== undefined)
    params.set("categorys", String(categoryIndex))
  const query = params.toString()
  return `/brands${query ? `?${query}` : ""}#all-brands`
}
